const isFalseyObject = (obj: Record<string, any>) =>
  !obj || Object.values(obj).every((x) => !x)

export default isFalseyObject
